export default "__VITE_ASSET__2b1438f7__"